/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import Link from 'react-router/lib/Link';
import { browserHistory } from 'react-router';
import get from 'lodash/get';

import { LOGIN, COMMUNITIES } from '../../../constants/routes';
import { actions as joinPopupActions } from '../../../redux/communities/joinPopup';
import { actions as uiSidebarActions } from '../../../redux/ui/sidebar';
import { actions as reqMemberInvitation } from '../../../redux/communities/reqMemberInvitation';
import {
  communityJoinPopupSelector,
  selectMemberInvitationTargetUser,
} from '../../../redux/communities/selectors/selectors';
import { uiSidebarSelector } from '../../../redux/ui/selectors';
import { isLoggedInSelector } from '../../../redux/auth/selectors';
import {
  COMMUNITIES_COMMON,
  AUTH,
  DIALOG_TITLE,
} from '../../../constants/strings';
import { isDesktop } from '../../../utils/mobileHelpers';

import Community from '../index';
import Icon from '../../Icon';
import Button from '../../Button';
import Popup from '../../common/Popup';
import MobileNavigation from '../../Communities/MobileNavigation';
import Content from '../../ContentArea/Content';
import ContentArea from '../../ContentArea';
import UserInviteForm from '../../UserInviteForm';
import brandConfig from '../../../constants/brandConfig';

import styles from '../index.styl';

const successMessagesMap = {
  email: AUTH.titles.sentEmailVerification,
  phone: AUTH.titles.sentPhoneVerification,
};

const mapStateToProps = state => ({
  joinPopup: communityJoinPopupSelector(state),
  isCommunityDrawerVisible: uiSidebarSelector(state),
  isLoggedIn: isLoggedInSelector(state),
  invitationTargetUser: selectMemberInvitationTargetUser(state),
});
const mapDispatchToProps = {
  openJoinPopup: joinPopupActions.show,
  hideJoinPopup: joinPopupActions.hide,
  toggleSidebarVisibility: uiSidebarActions.toggleVisibility,
  setPopupTimer: joinPopupActions.setTimer,
  stopPopupTimer: joinPopupActions.stopTimer,
  sendMemberInvitation: reqMemberInvitation.send,
};

@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class CommunityPreview extends Component {
  static propTypes = {
    routeParams: PropTypes.object.isRequired,
    openJoinPopup: PropTypes.func.isRequired,
    hideJoinPopup: PropTypes.func.isRequired,
    joinPopup: PropTypes.object.isRequired,
    invitationTargetUser: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    toggleSidebarVisibility: PropTypes.func.isRequired,
    isCommunityDrawerVisible: PropTypes.object.isRequired,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }).isRequired,
    stopPopupTimer: PropTypes.func.isRequired,
    setPopupTimer: PropTypes.func.isRequired,
    sendMemberInvitation: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isLoggedIn: null,
  };

  componentWillMount() {
    const {
      isLoggedIn,
      routeParams: { communityId },
    } = this.props;

    if (isLoggedIn) {
      browserHistory.push(`/${COMMUNITIES}/${communityId}`);
    }
  }

  componentDidMount() {
    const { setPopupTimer, isLoggedIn } = this.props;

    if (!isLoggedIn) {
      setPopupTimer({ delay: 15000 });
    }
  }

  handleTogglePopup = content => {
    const { openJoinPopup } = this.props;
    openJoinPopup({ content });
  };

  handleClosePopup = () => {
    const { joinPopup, hideJoinPopup, stopPopupTimer } = this.props;
    const { content } = joinPopup;

    switch (content) {
      case 'join':
        stopPopupTimer();
        hideJoinPopup();
        break;
      case 'signUp':
        this.handleTogglePopup('join');
        break;
      default:
        break;
    }
  };

  successContent = formatMessage => {
    const { invitationTargetUser } = this.props;
    let invitationType = 'email';

    if (get(invitationTargetUser, 'phoneNumber')) {
      invitationType = 'phone';
    }

    return (
      <div className="flex flex-column items-center pt4 pb2">
        <Icon className="db mb1" name="icon-plane" size={50} />
        <p className="mt4 pl5 pr5 tc">
          {formatMessage(successMessagesMap[invitationType])}
        </p>
      </div>
    );
  };

  joinPopup = formatMessage => (
    <div styleName="popup">
      <div className="flex flex-column items-center">
        <Icon
          name={brandConfig.logo}
          size={brandConfig.logoSize}
          style={{ fill: brandConfig.fillColor }}
        />
        <p styleName="popup-title">{formatMessage(COMMUNITIES_COMMON.join)}</p>
        <p styleName="popup-subtitle">
          {formatMessage(COMMUNITIES_COMMON.signUpToJoin)}
        </p>
      </div>
      <Button
        color="primary"
        className="w-80 mt4 mb4 f-14"
        onClick={() => this.handleTogglePopup('signUp')}
      >
        {formatMessage(AUTH.submit.signUp)}
      </Button>
      <p styleName="popup-subtitle">
        {formatMessage(DIALOG_TITLE.alreadyMember)}
        <Link to={LOGIN} styleName="popup-subtitle--primary">
          &nbsp;{formatMessage(AUTH.submit.login)}
        </Link>
      </p>
    </div>
  );

  userInviteForm = formatMessage => {
    const { sendMemberInvitation, routeParams } = this.props;
    return (
      <UserInviteForm
        formatMessage={formatMessage}
        sendInvite={sendMemberInvitation}
        closeInvitePopup={() => this.handleTogglePopup('join')}
        communityId={routeParams.communityId}
      />
    );
  };

  render() {
    const {
      routeParams,
      joinPopup,
      toggleSidebarVisibility,
      isCommunityDrawerVisible,
      isLoggedIn,
      intl: { formatMessage },
    } = this.props;

    const { visible: isPopupVisible, content: popupContent } = joinPopup;
    const toggleSidebar =
      isCommunityDrawerVisible.visible && toggleSidebarVisibility;
    const signUpPopup = popupContent === 'signUp';
    const isWithHeading = popupContent === 'join';
    const popup = {
      join: this.joinPopup(formatMessage),
      signUp: this.userInviteForm(formatMessage),
      success: this.successContent(formatMessage),
    };
    const MatchedComponent = popup[popupContent];

    if (isLoggedIn) {
      return null;
    }

    return (
      <div className="g-content" styleName="preview">
        <ContentArea className="relative">
          {isCommunityDrawerVisible.visible && (
            <MobileNavigation toggleContext={toggleSidebar} />
          )}
          <Content fullHeight>
            <Community routeParams={routeParams} />
            <Popup
              opened={isPopupVisible}
              white
              width={isDesktop() ? 'xsmall' : 'medium'}
              withHeading={isWithHeading}
              enabled
              title={
                signUpPopup ? formatMessage(AUTH.actions.signup.textLink) : ''
              }
              onClose={this.handleClosePopup}
            >
              {MatchedComponent}
            </Popup>
          </Content>
        </ContentArea>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/CommunityPreview/CommunityPreview.jsx